<payee-popup [heading]="dialogData?.transition_label">
  <ng-template #payeePopupTitleTemplate>
    <h1 class="title">{{ dialogData?.transition_label }}</h1>
  </ng-template>

  <ng-template #payeePopupDescriptionTemplate>
    <div class="description">
      {{ "WORKFLOW_DIALOGS.COFACE_CREATE_CASE.DESCRIPTION" | translate }}
    </div>
  </ng-template>

  @if (dataLoading()) {
    <div class="dialog-data-loading">
      <mat-progress-spinner
        mode="indeterminate"
        diameter="48"
      ></mat-progress-spinner>
    </div>
  }

  @if (dialogData && !dataLoading()) {
    <form
      class="dialog-content"
      [formGroup]="form"
    >
      <section class="party">
        <h2 class="subtitle">
          {{ "WORKFLOW_DIALOGS.COFACE_CREATE_CASE.DEBTOR" | translate }}
        </h2>
        @if (dialogData.debtor.name) {
          <p class="search-name">
            {{ "WORKFLOW_DIALOGS.COFACE_CREATE_CASE.SEARCH_NAME" | translate: { name: dialogData.debtor.name } }}
          </p>
        }

        <payee-form-field width="max">
          <payee-autocomplete
            [formControl]="debtorCompany"
            [options]="dialogData.debtor.companies"
            [displayWith]="displayCompany"
            [showAllOptionsOnFocus]="true"
            [placeholder]="'WORKFLOW_DIALOGS.COFACE_CREATE_CASE.PLACEHOLDER' | translate"
          >
            <ng-template
              #optionTemplate
              let-option
            >
              <div class="company-option">
                <div class="company-name">{{ option.name }}</div>
                @if (option.address) {
                  <div class="company-address">{{ option.address }}</div>
                }
                <div class="company-easy">{{ option.easyEstablishment }}</div>
              </div>
            </ng-template>
          </payee-autocomplete>
        </payee-form-field>

        @if (dialogData.debtor.companies.length === 0) {
          <p class="empty">
            {{ "WORKFLOW_DIALOGS.COFACE_CREATE_CASE.EMPTY" | translate }}
          </p>
        }
      </section>

      <section class="party">
        <h2 class="subtitle">
          {{ "WORKFLOW_DIALOGS.COFACE_CREATE_CASE.CLIENT" | translate }}
        </h2>
        @if (dialogData.client.name) {
          <p class="search-name">
            {{ "WORKFLOW_DIALOGS.COFACE_CREATE_CASE.SEARCH_NAME" | translate: { name: dialogData.client.name } }}
          </p>
        }

        <payee-form-field width="max">
          <payee-autocomplete
            [formControl]="clientCompany"
            [options]="dialogData.client.companies"
            [displayWith]="displayCompany"
            [showAllOptionsOnFocus]="true"
            [placeholder]="'WORKFLOW_DIALOGS.COFACE_CREATE_CASE.PLACEHOLDER' | translate"
          >
            <ng-template
              #optionTemplate
              let-option
            >
              <div class="company-option">
                <div class="company-name">{{ option.name }}</div>
                @if (option.address) {
                  <div class="company-address">{{ option.address }}</div>
                }
                <div class="company-easy">{{ option.easyEstablishment }}</div>
              </div>
            </ng-template>
          </payee-autocomplete>
        </payee-form-field>

        @if (dialogData.client.companies.length === 0) {
          <p class="empty">
            {{ "WORKFLOW_DIALOGS.COFACE_CREATE_CASE.EMPTY" | translate }}
          </p>
        }
      </section>
    </form>
  }

  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      width="max"
      [disabled]="loading || dataLoading()"
      [loading]="loading"
      (click)="submit()"
    >
      {{ "WORKFLOW_DIALOGS.COFACE_CREATE_CASE.SUBMIT" | translate }}
    </button>
  </ng-template>

  <ng-template #payeePopupCancelTemplate>
    <button
      payee-button
      color="white"
      width="max"
      [isBorderButton]="true"
      (click)="cancel()"
    >
      {{ "WORKFLOW_DIALOGS.COFACE_CREATE_CASE.CANCEL" | translate }}
    </button>
  </ng-template>
</payee-popup>
